import { dashTextToCamelCase, formatDateString } from '@routable/shared';
import dayjs from 'dayjs';
import _get from 'lodash/get';
import { hasLength, isObject } from 'helpers/utility';
import { getItemLedgerDisplayStatus } from 'modules/dashboard/existingItem/helpers';
export const getFieldProps = ({ dateFormat, decimalScale, item, ledger, minDecimalScale, name, options, lookupOptionLabelKey, parseFormat, }) => {
    let [fieldPath] = name.split('.').slice(-1);
    if (fieldPath.includes('extended_')) {
        fieldPath = fieldPath.replace('extended_', 'extended.').replace('_value', '');
    }
    fieldPath = dashTextToCamelCase(fieldPath.replace(/_+/g, '_'));
    const isAccountFieldLineItems = name.includes('lineItems.') && fieldPath === 'account';
    const isItemFieldLineItems = name.includes('lineItems.') && fieldPath === 'item';
    const isItemOrAccountFieldInLineItems = isAccountFieldLineItems || isItemFieldLineItems;
    if (isItemOrAccountFieldInLineItems) {
        fieldPath = `${fieldPath}.name`;
    }
    let value = _get(item, fieldPath);
    if (isAccountFieldLineItems) {
        const accountValue = _get(item, 'account');
        value = `${accountValue?.code ? `${accountValue.code}: ` : ''}${accountValue?.name}`;
    }
    if (fieldPath === 'taxStyle') {
        value = item?.extended?.taxStyle;
    }
    if (fieldPath === 'billCurrency') {
        value = item?.currencyCode;
    }
    else if (fieldPath === 'ledgerStatus') {
        value = getItemLedgerDisplayStatus(item, ledger);
    }
    else if (isObject(value)) {
        const option = options ? options.find((opt) => opt.id === value.id) : value;
        value = option?.[lookupOptionLabelKey] ?? option?.value ?? option?.name ?? option?.label ?? option?.number;
    }
    else if (hasLength(options) && !isItemOrAccountFieldInLineItems) {
        const option = options.find((opt) => opt.id === value);
        value = option?.label || option?.text;
    }
    else if (fieldPath === 'poMatchType' && !value) {
        value = 'Non-PO';
    }
    if (typeof minDecimalScale === 'number' && value) {
        value = new Intl.NumberFormat('en-US', {
            style: 'decimal',
            minimumFractionDigits: minDecimalScale,
            maximumFractionDigits: decimalScale,
        }).format(value);
    }
    if (dateFormat && value) {
        if (parseFormat) {
            const parsedDate = dayjs(value, parseFormat);
            if (parsedDate.isValid()) {
                value = parsedDate.format(dateFormat);
            }
        }
        else if (dayjs(value).isValid()) {
            value = formatDateString(value, dateFormat);
        }
    }
    return {
        fieldPath,
        value,
    };
};
